<script lang="ts">
  import DoubleChevronUpIcon from '$icons/arrows/DoubleChevronUpIcon.svelte';
  import ExpandIcon from '$icons/arrows/ExpandIcon.svelte';
  import ShrinkIcon from '$icons/arrows/ShrinkIcon.svelte';
  import XMarkIcon from '$icons/XMarkIcon.svelte';
  import { getPostEditor } from '$lib/stores/postEditorStore';
  import { cn } from '$lib/utils/misc';

  export let closeEditor: () => void;

  const { openState, activePost } = getPostEditor();

  function toggleFullscreen() {
    openState.set($openState === 'fullscreen' ? 'normal' : 'fullscreen');
  }

  function toggleMinimized() {
    if ($openState === 'minimized') {
      openState.set('normal');
    } else {
      openState.set('minimized');
    }
  }
</script>

<div class={cn('flex items-center justify-between gap-x-1')}>
  <h3
    class={cn(
      'text-gray-dark-12 font-architekt text-xs font-bold transition-opacity duration-300 sm:text-sm md:text-base',
      $openState === 'minimized' ? 'opacity-100' : 'opacity-0',
    )}
  >
    {#if $activePost}
      Post edits in progress. Tap to resume.
    {:else}
      Post draft in progress. Tap to resume.
    {/if}
  </h3>
  {#if $openState === 'minimized'}
    <button
      on:click={toggleMinimized}
      class="absolute inset-0 z-0 rounded bg-transparent p-2 focus:outline-none"
    ></button>
  {/if}
  <div class="flex gap-x-1">
    <button
      on:click={toggleFullscreen}
      class="hover:bg-gray-dark-4 z-10 hidden h-10 w-10 items-center justify-center rounded p-2 focus:outline-none sm:flex"
    >
      {#if $openState === 'fullscreen'}
        <ShrinkIcon class="h-5 w-5 text-white" />
      {:else}
        <ExpandIcon class="h-5 w-5 text-white" />
      {/if}
    </button>
    <button
      on:click={toggleMinimized}
      class="hover:bg-gray-dark-4 z-10 flex h-10 w-10 items-center justify-center rounded p-2 focus:outline-none"
    >
      {#if $openState === 'minimized'}
        <DoubleChevronUpIcon class="h-6 w-6 text-white" />
      {:else}
        <DoubleChevronUpIcon class="h-6 w-6 rotate-180 text-white" />
      {/if}
    </button>
    <button
      on:click={closeEditor}
      class="hover:bg-gray-dark-4 z-10 flex h-10 w-10 items-center justify-center rounded p-2 focus:outline-none"
    >
      <XMarkIcon class="h-5 w-5 text-white" />
    </button>
  </div>
</div>
